import { Info2Icon } from 'components/icons';
import { Modal } from 'components/index';
import { ROUTES } from 'utils/constants/constants_routes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from 'components/atoms/Button/Button';
import Link from 'components/atoms/Link/Link';
import React from 'react';
import styles from './TinkCloseModal.module.scss';

type Props = {
  isOpen: boolean;
  onRetry: () => void;
};

export default function TinkCloseModal({ isOpen, onRetry }: Props) {
  const { t } = useTranslation('tink_close_modal');
  const navigate = useNavigate();

  const handleNavigateDocuments = () => {
    navigate(ROUTES.FIRST_LOAN_ONLINE_BANK_ADD_DOCUMENTS);
  };

  const handleNavigateDocumentsLater = () => {
    navigate(ROUTES.FIRST_LOAN_TINK_LATER);
  };

  return (
    <Modal className={styles.modal} isOpen={isOpen} dataTest="tinkCloseModal">
      <div className={styles.container} data-testid="tink-close-modal">
        <Info2Icon
          className={styles['info-icon']}
          data-testid="tink-close-modal-info-icon"
        />
        <div data-testid="tink-close-modal-title">
          <div
            data-testid="tink-close-modal-title-text"
            className={styles.title}
          >
            {t('title')}
          </div>
        </div>
        <div
          className={styles.subtitle}
          data-testid="tink-close-modal-subtitle"
        >
          {t('subtitle')}
        </div>
        <Button
          fill
          dataTest="tink-close-modal-documents-btn"
          onClick={handleNavigateDocuments}
        >
          {t('btn_documents')}
        </Button>
        <div
          className={styles['later-hint']}
          data-testid="tink-close-modal-later-hint"
        >
          {t('btn_later_hint')}
        </div>
        <Button
          fill
          outlined
          dataTest="tink-close-modal-later-btn"
          onClick={handleNavigateDocumentsLater}
        >
          {t('btn_later')}
        </Button>
        <div
          className={styles['retry-section']}
          data-testid="tink-close-modal-retry-section"
        >
          <div
            data-testid="tink-close-modal-retry-hint"
            className={styles['retry-text']}
          >
            {t('retry_hint')}
          </div>
          <Link
            onClick={onRetry}
            dataTest="tink-close-modal-retry-link"
            className={styles['retry-link']}
          >
            {t('retry_link')}
          </Link>
        </div>
      </div>
    </Modal>
  );
}
